// Pattern matching a citation without annotation: [1], [12], [123]
export const citationRegexWithoutAnnotation = /(\[\d{1,3}\])/;
// Pattern matching a citation with annotation: [1, {ts:seconds}]
export const citationRegexWithAnnotation = /(\[\d{1,3},\s*\{ts:\d+\}\])/;
export const citationRegex = new RegExp(citationRegexWithoutAnnotation.source + '|' + citationRegexWithAnnotation.source);
// Returns the web result for the given citation (e.g. '[1]' is the
// first web result), or undefined if the given citation is not found.
// Does NOT modify the URL - annotation metadata is handled separately via CitationYoutubeAnnotation.
export const parseCitation = (citation, web_results) => {
    if (!citationRegex.test(citation)) {
        return undefined;
    }
    // Extract the citation index (works for both [1] and [1, {ts:123}] formats)
    const indexMatch = citation.match(/\[(\d{1,3})/);
    if (!indexMatch)
        return undefined;
    // we subtract one since search index in completion is off by 1
    const webResultIndex = parseInt(indexMatch[1], 10) - 1;
    return web_results?.[webResultIndex] ?? undefined;
};
//# sourceMappingURL=citations.js.map